import Icelib from './icelib-material.cjs';

export const { atoms, core, engines, molecules, organisms, presets, utils } = Icelib;
export default Icelib;
